import { render, staticRenderFns } from "./PublicUploadHandler.vue?vue&type=template&id=56ff03e8&scoped=true"
import script from "./PublicUploadHandler.vue?vue&type=script&lang=ts"
export * from "./PublicUploadHandler.vue?vue&type=script&lang=ts"
import style0 from "./PublicUploadHandler.vue?vue&type=style&index=0&id=56ff03e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff03e8",
  null
  
)

export default component.exports